import React, { Fragment, useState, useEffect } from "react";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint } from "@fortawesome/free-solid-svg-icons";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";

const EpicrisisListActions = ({ data, Callback, editEpicrisis, printClinicEpicrisis }) => {

  return (
    <Fragment>
      <td role="cell">
        <Tooltip title="Editar Epicrisis">
          <IconButton
            aria-label="delete-note"
            onClick={() => {
                editEpicrisis(data.data.original.nota_clinica, data.data.original.id_hist_nota_clin);
                Callback()
            }}
          >
            <EditOutlinedIcon />
          </IconButton>
        </Tooltip>
        
        <Tooltip title="Imprimir Epicrisis">
          <IconButton
            aria-label="print-note"
            onClick={() => {
                printClinicEpicrisis(data.data.original.id_hist_nota_clin);
            }}
          >
            <FontAwesomeIcon icon={faPrint} />
          </IconButton>
        </Tooltip>
      </td>
    </Fragment>)
};

export default EpicrisisListActions;
